module.exports = __webpack_public_path__ + "static/media/cs.43f56cd4.svg";